export default __webpack_public_path__ + "static/media/bm-2.8a034a54.png";